export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/app_website_previews.d8cb16a.svg";